const card = {
  baseStyle: {
    container: {
      borderRadius: "xl",
      border: "1px solid",
      borderColor: "app-border",
      boxShadow: "sm",
      bg: "app-card",
    },
  },
};

export default card;
